'use client'

/**
 * PDP REVIEWS_MINI (mobile-only "Review Highlights") — NON-DS.
 *
 * The backend emits REVIEWS_MINI as a container with three child widgets:
 *   - REVIEWS_HIGHLIGHT  → header: title + avg/count summary + the rating-range bars
 *   - REVIEWS_LIST       → the highlight review cards (reuses the non-DS ProductReviewHighLight)
 *   - REVIEWS_ALL_BUTTON → the "See all reviews" CTA
 *
 * REVIEWS_MINI itself carries no data; it just arranges its rendered children. Mobile-only is
 * handled upstream — the PL layout only emits this tree for MWEB.
 */

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'

import { ReviewsContainer } from '../shared/reviews-container'

export const ReviewsMiniWidget: PLTypedWidgetInterface<never, WidgetType.REVIEWS_MINI> = {
  id: WidgetType.REVIEWS_MINI,
  errorBoundary: PLBaseErrorBoundary,
  render: (props: PLTypedWidgetProps<never>) => (
    <ReviewsContainer variant="mini" renderedChildren={props.renderedChildren} />
  ),
}
